import React, { FC, useCallback, useState } from 'react';
import { cx } from 'linaria';
import { useSelector } from 'react-redux';
import { StorePlanModal } from 'features/store-common-info/store-plan-modal';
import { getPlankLink } from 'features/store/ducks/get-store-by-id';
import { button } from './styles';
import { StoreGeneralPlanImage } from '../../store-general-plan-image';

export const DATA_QA_STORE_PLAN_MOBILE = 'shop-plan-mobile';

type Props = {
  className?: string;
};

export const StorePlanMobile: FC<Props> = ({ className }) => {
  const [open, setOpen] = useState(false);
  const planLink = useSelector(getPlankLink) || '';
  const onClick = useCallback(() => setOpen(true), []);

  return (
    <>
      {planLink && (
        <div
          data-qa={DATA_QA_STORE_PLAN_MOBILE}
          className={cx(button, className)}
          onClick={onClick}
          onKeyDown={onClick}
        >
          <StoreGeneralPlanImage mobile />
        </div>
      )}
      <StorePlanModal imageUrl={planLink} onClose={() => setOpen(false)} show={open} />
    </>
  );
};
